import { render, staticRenderFns } from "./UploadIssueDocumentForm.vue?vue&type=template&id=048fcb66&scoped=true&"
import script from "./UploadIssueDocumentForm.vue?vue&type=script&lang=js&"
export * from "./UploadIssueDocumentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048fcb66",
  null
  
)

export default component.exports